module.exports = __webpack_public_path__ + "img/logo_idanhaanova.ce82242d.png";